import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/* FFC product tiles: quick add-to-cart + hover tilt */

const LABEL_RESET_MS = 1800;

function setLabel(btn, text, state) {
  const label = btn.querySelector('[data-ffc-label]') || btn;
  if (!btn.dataset.ffcDefault) btn.dataset.ffcDefault = label.textContent;
  label.textContent = text;
  if (state) btn.dataset.state = state;
  else btn.removeAttribute('data-state');
}

function resetLater(btn) {
  clearTimeout(btn._ffcTimer);
  btn._ffcTimer = setTimeout(() => setLabel(btn, btn.dataset.ffcDefault || 'Add to cart'), LABEL_RESET_MS);
}

async function refreshCart() {
  const items = document.querySelector('cart-items-component');
  if (items) {
    await customElements.whenDefined('cart-items-component');
    return items.fetchCartData();
  }
  const res = await fetch(`${Theme.routes.cart_url}.json`, { headers: { Accept: 'application/json' } });
  return res.json();
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-ffc-add')) return;
  event.preventDefault();

  const btn = form.querySelector('button[type="submit"]');
  if (!btn || btn.getAttribute('aria-busy') === 'true') return;
  btn.setAttribute('aria-busy', 'true');

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const data = await res.json();
    const cart = await refreshCart();

    if (data.status) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: true, items: cart.items, source: 'ffc-card', itemCount: 1 },
      });
      form.dispatchEvent(new CartErrorEvent({ error: data.message || 'Add to cart failed', code: 'INVALID' }));
      // Most common case for one-off cards: the only copy is already in the cart
      setLabel(btn, /already|all \d+|can't add|cannot add/i.test(data.description || data.message || '') ? 'Already in cart' : 'Unavailable', 'error');
    } else {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: false, items: cart.items, source: 'ffc-card', itemCount: 1, sections: data.sections },
      });
      setLabel(btn, 'Added ✓', 'added');
    }
  } catch (err) {
    console.error('[ffc-card]', err);
    deferred.reject(err);
    setLabel(btn, 'Try again', 'error');
  } finally {
    btn.removeAttribute('aria-busy');
    resetLater(btn);
  }
});

/* Holo tilt, same feel as the homepage cards */
const canTilt =
  !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.matchMedia('(hover: none)').matches;

if (canTilt) {
  document.addEventListener('pointermove', (e) => {
    const card = e.target instanceof Element ? e.target.closest('[data-ffc-card]') : null;
    if (!card) return;
    if (e.target.closest('.ffc-pc__actions')) {
      card.querySelector('.ffc-pc__in').style.transform = '';
      return;
    }
    const inner = card.querySelector('.ffc-pc__in');
    const holo = card.querySelector('.ffc-pc__holo');
    const r = card.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    inner.style.transform = `rotateY(${((px - 0.5) * 9).toFixed(2)}deg) rotateX(${((0.5 - py) * 9).toFixed(2)}deg)`;
    if (holo) {
      holo.style.setProperty('--mx', `${(px * 100).toFixed(1)}%`);
      holo.style.setProperty('--my', `${(py * 100).toFixed(1)}%`);
    }
  });
  document.addEventListener(
    'pointerleave',
    (e) => {
      if (e.target instanceof Element && e.target.matches('[data-ffc-card]')) {
        e.target.querySelector('.ffc-pc__in').style.transform = '';
      }
    },
    true
  );
}
